<script setup>
import { HeaderUnal, FooterUnal, ServicesMenu, LoadingScreen } from 'gaia-components-vue3'
</script>
<template>
  <HeaderUnal />
  <SidebarMenu/>
  <ServicesMenu/>
  <LoadingScreen v-if="loadingScreen" />
  <div class="router-view">
    <router-view />
  </div>
  <FooterUnal/>
</template>

<script>
import SidebarMenu from '../src/components/SidebarMenu/SidebarMenu.vue'
import { mapState } from 'vuex'

export default {
        title: 'Sistema de consultas',
        name:  'App',
        components:{
          SidebarMenu
        },
        computed: {
          ...mapState(['loadingScreen'])
        }
}
</script>

<style>

@font-face {
  font-family: "Ancizar sans";
  font-weight: bold;
  font-style: italic;
  src: url("assets/fonts/ancizarsans_bold_italic-webfont.eot"),
    url("assets/fonts/ancizarsans_bold_italic-webfont.eot?#iefix")
      format("embedded-opentype"),
    url("assets/fonts/ancizarsans_bold_italic-webfont.woff") format("woff"),
    url("assets/fonts/ancizarsans_bold_italic-webfont.ttf") format("truetype"),
    url("assets/fonts/ancizarsans_bold_italic-webfont.svg#ancizar_sansbold_italic")
      format("svg");
}

@font-face {
  font-family: "Ancizar sans";
  font-weight: bold;
  font-style: normal;
  src: url("assets/fonts/ancizarsans_bold-webfont.eot"),
    url("assets/fonts/ancizarsans_bold-webfont.eot?#iefix")
      format("embedded-opentype"),
    url("assets/fonts/ancizarsans_bold-webfont.woff") format("woff"),
    url("assets/fonts/ancizarsans_bold-webfont.ttf") format("truetype"),
    url("assets/fonts/ancizarsans_bold-webfont.svg#ancizar_sansbold_italic")
      format("svg");
}

@font-face {
  font-family: "Ancizar sans";
  font-weight: normal;
  font-style: italic;
  src: url("assets/fonts/ancizarsans_italic-webfont.eot"),
    url("assets/fonts/ancizarsans_italic-webfont.eot?#iefix")
      format("embedded-opentype"),
    url("assets/fonts/ancizarsans_italic-webfont.woff") format("woff"),
    url("assets/fonts/ancizarsans_italic-webfont.ttf") format("truetype"),
    url("assets/fonts/ancizarsans_italic-webfont.svg#ancizar_sansbold_italic")
      format("svg");
}

@font-face {
  font-family: "Ancizar sans";
  font-weight: normal;
  font-style: normal;
  src: url("assets/fonts/ancizarsans_regular-webfont.eot"),
    url("assets/fonts/ancizarsans_regular-webfont.eot?#iefix")
      format("embedded-opentype"),
    url("assets/fonts/ancizarsans_regular-webfont.woff") format("woff"),
    url("assets/fonts/ancizarsans_regular-webfont.ttf") format("truetype"),
    url("assets/fonts/ancizarsans_regular-webfont.svg#ancizar_sansbold_italic")
      format("svg");
}

@font-face {
  font-family: "Ancizar serif";
  font-weight: bold;
  font-style: italic;
  src: url("assets/fonts/ancizarserif_bold_italic-webfont.eot"),
    url("assets/fonts/ancizarserif_bold_italic-webfont.eot?#iefix")
      format("embedded-opentype"),
    url("assets/fonts/ancizarserif_bold_italic-webfont.woff") format("woff"),
    url("assets/fonts/ancizarserif_bold_italic-webfont.ttf") format("truetype"),
    url("assets/fonts/ancizarserif_bold_italic-webfont.svg#ancizar_sansbold_italic")
      format("svg");
}

@font-face {
  font-family: "Ancizar serif";
  font-weight: bold;
  font-style: normal;
  src: url("assets/fonts/ancizarserif_bold-webfont.eot"),
    url("assets/fonts/ancizarserif_bold-webfont.eot?#iefix")
      format("embedded-opentype"),
    url("assets/fonts/ancizarserif_bold-webfont.woff") format("woff"),
    url("assets/fonts/ancizarserif_bold-webfont.ttf") format("truetype"),
    url("assets/fonts/ancizarserif_bold-webfont.svg#ancizar_sansbold_italic")
      format("svg");
}

@font-face {
  font-family: "Ancizar serif";
  font-weight: normal;
  font-style: italic;
  src: url("assets/fonts/ancizarserif_italic-webfont.eot"),
    url("assets/fonts/ancizarserif_italic-webfont.eot?#iefix")
      format("embedded-opentype"),
    url("assets/fonts/ancizarserif_italic-webfont.woff") format("woff"),
    url("assets/fonts/ancizarserif_italic-webfont.ttf") format("truetype"),
    url("assets/fonts/ancizarserif_italic-webfont.svg#ancizar_sansbold_italic")
      format("svg");
}

@font-face {
  font-family: "Ancizar serif";
  font-weight: normal;
  font-style: normal;
  src: url("assets/fonts/ancizarserif_regular-webfont.eot"),
    url("assets/fonts/ancizarserif_regular-webfont.eot?#iefix")
      format("embedded-opentype"),
    url("assets/fonts/ancizarserif_regular-webfont.woff") format("woff"),
    url("assets/fonts/ancizarserif_regular-webfont.ttf") format("truetype"),
    url("assets/fonts/ancizarserif_regular-webfont.svg#ancizar_sansbold_italic")
      format("svg");
}

.router-view {
  margin: 1.5rem auto;
  max-width: 100%;
  min-height: 60vh;
  overflow-x: hidden;
}

.breadcrumb-class {
  border-bottom: 1px dotted #646464;
}

</style>
